// Generated by https://quicktype.io

export interface Page {
  post_content: string
  post_date: string
  post_title: string
  fields: Fields
  post_thumbnail: boolean
}

export interface Litery {
  title:   string;
  content: string;
  audio:   Audio;
  letter:  string;
}

export interface Question {
  question: string
  audio: Audio | null
  image: Photo
  name: string
  content: string
}

export interface Fields {
  sections: Section[]
  audio: Audio
}

export interface Section {
  title: string
  content: string
  layout: SectionLayouts
  Image: Photo | null
  audio: Audio
  popup: Popup
  books: Book[] | null
  wise_heads: boolean | WiseHead
  questions: boolean | Question
  litery: boolean | Litery
}

export interface WiseHead {
    image:       Photo;
    name:        string;
    description: string;
    audio:       Audio;
    audio2:       Audio;
}


export interface Audio {
  file?: string
  title: string
  description: string
  url?: string
}

export interface Book {
  title: string
  cover: Photo
  popup: Popup
}

export interface Photo {
  ID: number
  id: number
  title: string
  filename: string
  filesize: number
  url: string
  link: string
  alt: string
  author: string
  description: string
  caption: string
  name: string
  status: Status
  uploaded_to: number
  date: string
  modified: string
  menu_order: number
  mime_type: MIMEType
  type: Type
  subtype: Subtype
  icon: string
  width: number
  height: number
  sizes: Sizes
}

export enum MIMEType {
  ImageJPEG = "image/jpeg",
}

export interface Sizes {
  thumbnail: string
  "thumbnail-width": number
  "thumbnail-height": number
  medium: string
  "medium-width": number
  "medium-height": number
  medium_large: string
  "medium_large-width": number
  "medium_large-height": number
  large: string
  "large-width": number
  "large-height": number
  "1536x1536": string
  "1536x1536-width": number
  "1536x1536-height": number
  "2048x2048": string
  "2048x2048-width": number
  "2048x2048-height": number
}

export enum Status {
  Inherit = "inherit",
}

export enum Subtype {
  JPEG = "jpeg",
}

export enum Type {
  Image = "image",
}

export enum SectionLayouts {
  A = "A",
  B = "B",
  C = "C",
}

export interface Popup {
  title: string
  content: string
  audio: Audio
  image: Photo | null
}
